import {Link} from 'react-router-dom';
import Message from '../../components/message/Message';
import MetaTags from '../../components/common/MetaTags';
import PropTypes from 'prop-types';
import React from 'react';
import SquareButton from '../../components/squareButton/SquareButton';
import {generateRoutePath} from '@epic-core/common';

/**
 * 500 component.  Shown user runs into a site error.
 *
 */
const Error500 = function Error500({staticContext}) {
    if (staticContext) {
        staticContext.status = 500;
    }
    return (
        <div className="error500 errorPages">
            <MetaTags meta={{title: '500'}} />
            <div className="content">
                <div className="error-header">
                    <h1>500</h1>
                    <h2>
                        <Message code="epic.unrealtournament.500.title1" />
                        <br />
                        <Message code="epic.unrealtournament.500.title2" />
                    </h2>
                </div>
                <p><Message code="epic.unrealtournament.500.subtitle" /></p>
                <div className="error-btn">
                    <Link className="btn" to={generateRoutePath('/')}>
                        <SquareButton config={{dark: true}}><Message code="epic.unrealtournament.500.return" /></SquareButton>
                    </Link>
                </div>
                
                
            </div>
        </div>
    );
};

Error500.propTypes = {
    staticContext: PropTypes.object
};

export default Error500;
